import { createTheme } from '@mui/material/styles';

const shared = {
  typography: {
    fontFamily: "'Inter', 'Poppins', sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif", fontWeight: 800 },
    h2: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h4: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h5: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    button: { fontWeight: 600, letterSpacing: '0.02em' },
  },
  shape: { borderRadius: 16 },
  shadows: [
    'none',
    '0 1px 3px 0 rgb(0 0 0 / 0.05)',
    '0 4px 6px -1px rgb(0 0 0 / 0.07)',
    '0 10px 15px -3px rgb(0 0 0 / 0.08)',
    '0 20px 25px -5px rgb(0 0 0 / 0.08)',
    '0 25px 50px -12px rgb(0 0 0 / 0.1)',
    ...Array(19).fill('none'),
  ],
};

export function createAppTheme(mode = 'light') {
  const dark = mode === 'dark';

  return createTheme({
    ...shared,
    palette: {
      mode,
      primary: {
        main: '#6366f1',
        light: '#818cf8',
        dark: '#4f46e5',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
      },
      background: {
        default: dark ? '#0f0f1a' : '#fafafa',
        paper:   dark ? '#1a1a2e' : '#ffffff',
      },
      text: {
        primary:   dark ? '#f1f5f9' : '#111827',
        secondary: dark ? '#94a3b8' : '#6b7280',
      },
      success: { main: '#10b981' },
      error:   { main: '#ef4444' },
      grey: { 50: '#f9fafb', 100: '#f3f4f6', 200: '#e5e7eb' },
      divider: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 50,
            padding: '10px 28px',
            textTransform: 'none',
            fontSize: '0.95rem',
            boxShadow: 'none',
            '&:hover': { boxShadow: '0 8px 25px -5px rgba(99,102,241,0.4)' },
          },
          containedPrimary: {
            background: 'linear-gradient(135deg, #6366f1 0%, #818cf8 100%)',
            '&:hover': { background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)' },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 20,
            border: dark ? '1px solid rgba(99,102,241,0.15)' : '1px solid rgba(99,102,241,0.08)',
            boxShadow: dark ? '0 4px 24px -4px rgba(0,0,0,0.4)' : '0 4px 24px -4px rgba(99,102,241,0.12)',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 8, fontWeight: 600 },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            background: dark ? '#1a1a2e' : '#ffffff',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
        },
      },
    },
  });
}

export default createAppTheme('light');
